import type { BlockRendererMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

import { Renderer } from "./Renderer";

export interface BlockListProps {
  basePath?: string;
  blocks: BaseBlock[];
  components: BlockRendererMapping;
}

export const RenderBlockList = ({
  basePath,
  blocks,
  components,
}: BlockListProps) => (
  <>
    {blocks.map((block, index) => (
      <Renderer
        key={block.id}
        block={block}
        components={components}
        path={basePath ? `${basePath}.${index}` : undefined}
      />
    ))}
  </>
);
